import { React, useState, useEffect, useContext} from 'react';
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";

import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant";
import { AuthContext } from '../../../component/context/AuthContext';
import { Link } from 'react-router-dom';
import DivSpinner from '../../../component/utilities/Spinner';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import moment from 'moment';
import { differenceInCalendarMonths } from 'date-fns';
import ShowDetails from '../employee/ShowDetails';
import ModalViewResignation from './ModalViewResignation';
import ITCheck from './ITCheck';
import AccountClearance from './AccountClearance';
// Component to display and manage a list of employee resignations
function ResignationList() {
  // Authentication context and user data
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [fullLoading, setFullLoading] = useState(false);
  const [validate, setValidate] = useState({});
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [srchEmpName, setSrchEmpName] = useState("");
  const [srchEmpEmail, setSrchEmpEmail] = useState("");
  const [srchEmpStatus, setSrchEmpStatus] = useState("");
  const [dptListing, setDptListing] = useState("");
  const [srchdesignation, setsrchDesignation] = useState("");
  const [desigListing, setDesigListing] = useState("");
  const [resignationData, setResignationData] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isEmpDetailModalShow, setEmpDetailModalShow] = useState(false);
  const [showEmpDetailsModel, setEmpDetailsShowModel] = useState({ show: 'hide' });
  const [showResignationModal, setResignationModal] = useState({ show: 'hide' });

  // New state for IT Clearance
  // Add this with your other states
  const [showItCheckModal, setShowItCheckModal] = useState({ show: "hide" });
  const [itCheckData, setItCheckData] = useState(null);

  const [showAccountClearanceModal, setShowAccountClearanceModal] = useState({
    show: "hide",
  });
  const [accountClearanceData, setAccountClearanceData] = useState(null);

  const handleAccountClearanceModal = (row) => {
    setLoading(true);
    setShowAccountClearanceModal({ show: "show" });
    setAccountClearanceData(row);
    setLoading(false);
  };

  const closeAccountClearanceModal = () => {
    setShowAccountClearanceModal({ show: "hide" });
    setAccountClearanceData(null);
    fetchResignationData(searchParam, dataSort, activePage, perPage);
  };
  // Handler to open the IT Check
  const handleItCheckModal = (row) => {
    setItCheckData(row);
    setShowItCheckModal({ show: "show" });
  };

  // Handler to close the IT Check
  const closeItCheckModal = () => {
    setShowItCheckModal({ show: "hide" });
    setItCheckData(null);
    fetchResignationData(searchParam, dataSort, activePage, perPage);
  };

  // Initialize user authentication details
  let isToken = '';
  // let user_id = '';
  let department_id = '';
  // let is_head = 0;
  let is_admin = 0;
  // let hr_head = 0;
  let default_dpt_id = '';
  if (authUserData && authUserData[0]) {
    isToken = authUserData[0].token || "";
    // user_id = authUserData[0].user_id || "";
    // is_head = authUserData[0].is_head || 0;
    is_admin = authUserData[0].is_admin || 0;
    // hr_head = authUserData[0].hr_head || 0;
    department_id = authUserData[0].department_id || "";
  }

  // Set default department ID based on user role
  if (is_admin == 1) {
    default_dpt_id = "";
  } else if (department_id !== 5 && department_id !== 8 && department_id !== 9) {
    default_dpt_id = department_id;
  } else {
    default_dpt_id = "";
  }

  const [srchEmpDepartment, setSrchEmpDepartment] = useState(default_dpt_id);

  // DataTable pagination states
  const [totalRecords, settotalRecords] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(50);
  const [maxPageLimit, setMaxPageLimit] = useState(10);
  const [minPageLimit, setMinPageLimit] = useState(0);
  // Search parameters
  const [searchParam, setSearchParam] = useState({
    srchEmpName,
    srchEmpEmail,
    srchEmpStatus,
    srchEmpDepartment,
    srchdesignation,
  });
  // Sorting parameters
  const [dataSort, setDataSort] = useState({
    order: 'desc',
    order_by: 'id'
  });
  const [activePage, setActivePage] = useState(1);

  // Fetch data on component mount or when search/sort/page changes
  useEffect(() => {
    fetchResignationData(searchParam, dataSort, activePage, perPage);
    
    // fetchDesigtList(srchEmpDepartment);
  }, [searchParam, dataSort, activePage, perPage]);

  // State for editing employee
  const [editEmpId, setEditEmpId] = useState("");
  const [showModel, setShowModel] = useState({ show: 'hide' });

  // Close employee details modal
  const closeEmpDetails = async () => {
    setEmpDetailsShowModel({ show: 'hide' });
  };
  const closeResignationModal = async () => {
    setResignationModal({ show: 'hide' });
    fetchResignationData(searchParam, dataSort, activePage, perPage);
  };

  // Handle child component callback to refresh data
  const childToParent = async () => {
    setShowModel({ show: 'hide' });
    fetchResignationData(searchParam, dataSort, activePage, perPage);
  };

  // Calculate employee experience
  function calculateExperience(startDate, endDate) {
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = endDate === 'present' ? new Date() : new Date(endDate);
      const totalMonths = differenceInCalendarMonths(end, start);
      const years = Math.floor(totalMonths / 12);
      const months = totalMonths % 12;
      return years + months / 10; // Display one decimal place
    }
    return 0;
  }

  // Component to render employee name and details
  const ColEmployeeName = ({ row }) => (
    <div>
      <div className="d-flex py-1 align-items-center">
        {row.user.profile_photo_path ? (
          <span className="avatar">
            <img src={CONST.HOST + row.user.profile_photo_path} alt='' width={40} className="rounded-circle" />
          </span>
        ) : (
          <span className="avatar rounded-circle">
            <span>
              <Link to={'#'} data-id={row.user.id} onClick={() => handleEmpDetailsShow(row)}>
                {(row.user.first_name && row.user.last_name)
                  ? `${row.user.first_name.substring(0, 1)}${row.user.last_name.substring(0, 1)}`
                  : row.user.name?.substring(0, 2)}
              </Link>
            </span>
          </span>
        )}
        <div className="flex-fill pl-2">
          <div className="font-weight-medium">
            <Link to={'#'} data-id={row.user.id} onClick={() => handleEmpDetailsShow(row)}>
              {(row.user.first_name && row.user.last_name) ? (
                <LinkWithTooltip tooltip="View More Information" id="more-information" css="color_blue">
                  {`${row.user.first_name} ${row.user.last_name}`}
                </LinkWithTooltip>
              ) : row.user.name}
            </Link>
          </div>
          <div className="text-muted">
            <Link target="_blank" to={`mailto:${row.user.email}`} className="text-muted">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-mail mr-1">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" />
                <path d="M3 7l9 6l9 -6" />
              </svg>
              {row.user.email.toLowerCase()}
            </Link>
          </div>
          {row.user.phone_number && (
            <div className="text-muted">
              <LinkWithTooltip tooltip="Phone Number" href="#" id="phone_number" class="">
                <Link href={`tel:${row.user.phone_number}`} className="text-reset">
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-phone-call mr-1" width="12" height="12" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"></path>
                    <path d="M15 7a2 2 0 0 1 2 2"></path>
                    <path d="M15 3a6 6 0 0 1 6 6"></path>
                  </svg>
                  {row.user.phone_number}
                </Link>
              </LinkWithTooltip>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // Component to render employee designation and department
  const ColEConnection = ({ row }) => (
    <div className="flex-fill">
      <div className="font-weight-medium">
        {row.user.designation ? row.user.designation.name : "-"}
      </div>
      <div className="text-muted">
        {row.user.department ? row.user.department.name : "-"}
      </div>
    </div>
  );


  // Component to render joining date
  const ColJoiningDate = ({ row }) => (
    <div>
      {row.user.date_of_joining ? (
        <div>
          <LinkWithTooltip tooltip="Date of Joining" href="#" id="date_of_joining" class="">
            {moment(row.user.date_of_joining).format('DD-MM-YYYY')}
          </LinkWithTooltip>
        </div>
      ):("-")}
    </div>
  );

  // Component to render resignation date
  const ColResignationDate = ({ row }) => (
    <div>
      {row.applied_date ? (
        <div>
          <LinkWithTooltip tooltip="Resignation Date" href="#" id="date_of_joining" class="">
            {moment(row.applied_date).format('DD-MM-YYYY')}
          </LinkWithTooltip>
        </div>
      ):("-")}
    </div>
  );

  // Component to render release date
  const ColReleaseDate = ({ row }) => (
    <div>
      {row.release_date ? (
        <div>
          <LinkWithTooltip tooltip="Release date" href="#" id="release_date" class="">
            {moment(row.release_date).format('DD-MM-YYYY')}
          </LinkWithTooltip>
        </div>
      ) : (
        "-"
      )}
    </div>
  );

  // Component to render action buttons
  const ColAction = ({ row }) => (
    <>
      <div>
        <Link
          to={"#"}
          data-id={row.user.id}
          onClick={() => handleResignationModal(row)}
        >
          <LinkWithTooltip
            tooltip="View Resignation Details"
            id="view-resignation-details"
            css="color_blue"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="cursor mr-2 icon icon-tabler icon-tabler-list-check"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M3.5 5.5l1.5 1.5l2.5 -2.5"></path>
              <path d="M3.5 11.5l1.5 1.5l2.5 -2.5"></path>
              <path d="M3.5 17.5l1.5 1.5l2.5 -2.5"></path>
              <path d="M11 6l9 0"></path>
              <path d="M11 12l9 0"></path>
              <path d="M11 18l9 0"></path>
            </svg>
          </LinkWithTooltip>
        </Link>
      </div>
      {department_id == 8 && row.current_step == 3 && row.final_status ==	"Pending"  && (
        <div>
          <Link
            to={"#"}
            onClick={(e) => {
              e.preventDefault();
              handleItCheckModal(row); // This opens the IT Check
            }}
          >
            <LinkWithTooltip
              tooltip="Process IT Clearance"
              id="it-clearance-btn"
              css="color_blue"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="cursor mr-2 icon icon-tabler icon-tabler-door-exit"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M13 12v.01"></path>
                <path d="M3 21h18"></path>
                <path d="M5 21v-16a2 2 0 0 1 2 -2h7.5m2.5 10.5v7.5"></path>
                <path d="M14 7h7m-3 -3l3 3l-3 3"></path>
              </svg>
            </LinkWithTooltip>
          </Link>
        </div>
      )}
      {department_id == 9 && row.current_step == 4 && row.final_status ==	"Pending" && (
        <div>
          <Link
            to={"#"}
            onClick={(e) => {
              e.preventDefault();
              handleAccountClearanceModal(row); // Accounts uses the same modal as HR
            }}
          >
            <LinkWithTooltip
              tooltip="Process Accounts Clearance"
              id="accounts-clearance-btn"
              css="color_blue"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-coin-rupee"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                <path d="M15 8h-6h1a3 3 0 0 1 0 6h-1l3 3" />
                <path d="M9 11h6" />
              </svg>
            </LinkWithTooltip>
          </Link>
        </div>
      )}
    </>
  );

  // DataTable column definitions
  const columns = [
    {
      name: "Employee",
      cell: (row) => <ColEmployeeName row={row} />,
      sortable: true,
      sortField: "first_name",
      width: '22%',
      wrap: true,
    },
    {
      name: "Department",
      cell: (row) => (
        <div>
          <div style={{ fontWeight: 600, fontSize: '0.85rem', color: '#0a1628' }}>{row.user?.designation?.name || ''}</div>
          <div style={{ fontSize: '0.75rem', color: '#64748b' }}>{row.user?.department?.name || ''}</div>
        </div>
      ),
      width: '15%',
      wrap: true,
    },
    {
      name: "Joining Date",
      cell: (row) => <span style={{ fontSize: '0.85rem' }}>{row.user?.date_of_joining ? moment(row.user.date_of_joining).format("DD MMM YYYY") : "-"}</span>,
      width: '12%',
      wrap: true,
    },
    {
      name: "Applied Date",
      cell: (row) => <span style={{ fontSize: '0.85rem' }}>{row.applied_date ? moment(row.applied_date).format("DD MMM YYYY") : "-"}</span>,
      width: '12%',
      wrap: true,
    },
    {
      name: "Release Date",
      cell: (row) => <span style={{ fontSize: '0.85rem', color: row.release_date ? '#059669' : '#d97706' }}>{row.release_date ? moment(row.release_date).format("DD MMM YYYY") : "Not Set"}</span>,
      width: '12%',
      wrap: true,
    },
    {
      name: "Current Step",
      cell: (row) => {
        const stepNames = { 1: "Applied", 2: "HR Review", 3: "IT Clearance", 4: "Accounts", 5: "HR Final" };
        return <span style={{ fontSize: '0.78rem', color: '#1167e8', fontWeight: 600 }}>{stepNames[row.current_step] || `Step ${row.current_step}`}</span>;
      },
      width: '10%',
      wrap: true,
    },
    {
      name: "Status",
      width: '9%',
      wrap: true,
      cell: (row) => {
        const s = row.final_status || "Pending";
        const map = { "Approved": { bg: '#ecfdf5', color: '#059669' }, "Rejected": { bg: '#fef2f2', color: '#dc2626' }, "Withdrawn": { bg: '#f1f5f9', color: '#94a3b8' }, "Pending": { bg: '#fffbeb', color: '#d97706' } };
        const st = map[s] || map["Pending"];
        return <span style={{ background: st.bg, color: st.color, padding: '3px 10px', borderRadius: 20, fontSize: '0.7rem', fontWeight: 600 }}>{s}</span>;
      },
    },
    {
      name: "Action",
      cell: (row) => <ColAction row={row} />,
      sortable: false,
      width: '8%',
      wrap: true,
    }
  ];

  // Handle search button click
  const handleSearch = () => {
    setSearchParam({
      srchEmpName,
      srchEmpEmail,
      srchEmpStatus,
      srchEmpDepartment,
      srchdesignation,
    });
    setDataSort({
      order: 'desc',
      order_by: 'id'
    });
    setActivePage(1);
  };

  // Reset search filters
  const handleReSetSearch = () => {
    setSrchEmpName("");
    setSrchEmpEmail("");
    setSrchEmpStatus("");
    setSrchEmpDepartment("");
    setActivePage(1);
    setSearchParam({
      srchEmpName: "",
      srchEmpEmail: "",
      srchEmpStatus: "",
      srchEmpDepartment: "",
      srchdesignation: "",
    });
    setDataSort({
      order: 'desc',
      order_by: 'id'
    });
    setActivePage(1);
  };

  // Show employee details modal
  const handleEmpDetailsShow = (row) => {
    setLoading(true);
    setEmpDetailModalShow(true);
    setEmpDetailsShowModel({ show: 'show' });
    setEditEmpId(row.user.id);
    setFirstName(row.user.first_name || '');
    setLastName(row.user.last_name || '');
    setLoading(false);
  };

  const handleResignationModal = row => {
    setLoading(true);
    setResignationModal({ show: 'show' });
    setResignationData(row);
    setLoading(false);
  }

  // Handle column sorting
  const handleSort = async (column, sortDirection) => {
    setSrchEmpName("");
    setSrchEmpEmail("");
    setSrchEmpStatus("");
    setSrchEmpDepartment("");
    setActivePage(1);
    setDataSort({
      order: sortDirection,
      order_by: column.sortField
    });
    fetchResignationData(
      { srchEmpName, srchEmpEmail, srchEmpStatus, srchEmpDepartment },
      { order: sortDirection, order_by: column.sortField },
      activePage,
      perPage
    );
  };

  // Fetch department list
  async function fetchDeptList() {
    setLoading(true);
    await axios
      .get(CONST.GET_DEPARTMENT, {
        headers: { 'Authorization': `Bearer ${isToken}` }
      })
      .then((response) => {
        if (response.data.status === 'success') {
          setDptListing(response.data.data);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
    setLoading(false);
  }

  // Fetch resignation data
  async function fetchResignationData(paramSearch, paramSort, paramPage, paramLimit) {
    setLoading(true);
    if(department_id === 5 ||department_id === 8 ||is_admin == 1){await fetchDeptList();}
    
    await axios.post(
      CONST.GET_RESIGNATION_LIST,
      {
        limit: paramLimit,
        page_number: paramPage,
        search_input: paramSearch,
        sort: paramSort,
      },
      {
        headers: { Authorization: `Bearer ${isToken}` }
      }
    )
      .then((response) => {
        if (response.data.status === 'success') {
          setTotalRows(response.data.count);
          setData(response.data.data);
          settotalRecords(response.data.count);
        } else {
          setTotalRows("0");
          setData("");
          settotalRecords("0");
        }
      })
      .catch((error) => {
        setTotalRows("0");
        setData("");
        settotalRecords("0");
        toast.error("There was an error.");
      });

    setLoading(false);
  }

  // Handle rows per page change
  const handlePageLimit = async (val) => {
    setSrchEmpName("");
    setSrchEmpEmail("");
    setSrchEmpStatus("");
    setSrchEmpDepartment("");
    setActivePage(1);
    setSearchParam({
      srchEmpName: "",
      srchEmpEmail: "",
      srchEmpStatus: "",
      srchEmpDepartment: "",
      srchdesignation: "",
    });
    setDataSort({
      order: 'desc',
      order_by: 'id'
    });
    setActivePage(1);
    setPerPage(parseInt(val));
  };

  // Handle page change
  const handlePageChange = async (page) => {
    setActivePage(parseInt(page));
  };

  // Custom pagination component
  const BootyPagination = ({ rowsPerPage, rowCount, onChangePage, currentPage }) => {
    function toPages(pages) {
      const results = [];
      for (let i = 1; i <= pages; i++) {
        results.push(i);
      }
      return results;
    }

    function getNumberOfPages(rowCount, rowsPerPage) {
      return Math.ceil(rowCount / rowsPerPage);
    }

    const handleBackButtonClick = async () => {
      if ((currentPage - 1) % perPage === 0) {
        setMaxPageLimit(maxPageLimit - perPage);
        setMinPageLimit(minPageLimit - perPage);
      }
      onChangePage(currentPage - 1);
    };

    const handleNextButtonClick = async () => {
      if (currentPage + 1 > maxPageLimit) {
        setMaxPageLimit(maxPageLimit + perPage);
        setMinPageLimit(minPageLimit + perPage);
      }
      onChangePage(currentPage + 1);
    };

    const handlePageNumber = (e) => {
      onChangePage(Number(e.target.value));
    };

    let paginationText = `Page: ${currentPage}, Showing ${(currentPage - 1) * perPage + 1} to ${perPage * currentPage} of ${rowCount} entries;`;

    const pages = getNumberOfPages(rowCount, perPage);
    const pageItems = toPages(pages);
    const nextDisabled = currentPage === pageItems.length;
    const previosDisabled = currentPage === 1;

    const pageNumbers = pageItems.map((page, index) => {
      if (page <= maxPageLimit && page > minPageLimit) {
        return (
          <li key={index} id={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
            <button className={`page-link ${currentPage === page ? "active" : ""}`} onClick={handlePageNumber} value={page}>
              {page}
            </button>
          </li>
        );
      }
      return null;
    });

    let pageIncrementEllipses = pageItems.length > maxPageLimit ? (
      <li className="page-item" onClick={handleNextButtonClick}>&hellip;</li>
    ) : null;

    let pageDecremenEllipses = minPageLimit >= 1 ? (
      <li className="page-item" onClick={handleBackButtonClick}>&hellip;</li>
    ) : null;

    return (
      <div className='row card-footer'>
        <div className='col-md-4 align-self-center'>{paginationText}</div>
        <div className='col-md-8 text-align-right'>
          <ul className="pagination pagination text-align-right float-right">
            <li className="page-item">
              <button className="page-link" onClick={handleBackButtonClick} disabled={previosDisabled} aria-disabled={previosDisabled} aria-label="previous page" pageRangeDisplayed={10}>
                «
              </button>
            </li>
            {pageDecremenEllipses}
            {pageNumbers}
            {pageIncrementEllipses}
            <li className="page-item">
              <button className="page-link" onClick={handleNextButtonClick} disabled={nextDisabled} aria-disabled={nextDisabled} aria-label="next page">
                »
              </button>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  // Custom loading component for DataTable
  const CustomLoader = () => (
    <div style={{ padding: "24px" }}>
      <DivLoader color="primary" />
    </div>
  );

  // Fetch designation list based on department ID
  const fetchDesigtList = async (desig_id) => {
    setSrchEmpDepartment(desig_id);
    await axios
      .get(`${CONST.GET_DESIG_BY_ID}/${desig_id}`, {
        headers: { 'Authorization': `Bearer ${isToken}` }
      })
      .then((response) => {
        if (response.data.status === 'success') {
          setDesigListing(response.data.data);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  // Component for rendering tooltips
  function LinkWithTooltip({ id, children, href, tooltip, css }) {
    return (
      <OverlayTrigger overlay={<Tooltip id={id}>{tooltip}</Tooltip>} placement="top" delayShow={300} delayHide={150}>
        <span className={css}>{children}</span>
      </OverlayTrigger>
    );
  }

  // Render the resignation list component
  return (
    <>
      <Loading
        loading={fullLoading}
        background="rgba(0, 0, 0, 0.5)"
        loaderColor="#fff"
      />
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <div className="page-pretitle">Manage</div>
              <h2 className="page-title">Resignations</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-cards">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Listing</h3>
                </div>
                <div className="card-body border-bottom py-3">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group mb-3">
                        <label className="form-label required">Name</label>
                        <input
                          type="text"
                          name="srchEmpName"
                          id="srchEmpName"
                          className={`form-control ${validate.validate?.srchEmpName ? "is-invalid" : ""}`}
                          aria-describedby="emailHelp"
                          placeholder="Enter name"
                          onChange={(e) => setSrchEmpName(e.target.value)}
                          value={srchEmpName}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group mb-3">
                        <label className="form-label required">Email</label>
                        <input
                          type="text"
                          name="srchEmpEmail"
                          id="srchEmpEmail"
                          className={`form-control ${validate.validate?.srchEmpEmail ? "is-invalid" : ""}`}
                          aria-describedby="emailHelp"
                          placeholder="Enter email"
                          onChange={(e) => setSrchEmpEmail(e.target.value)}
                          value={srchEmpEmail}
                        />
                      </div>
                    </div>
                    {(department_id === 5 ||
                      department_id === 8 ||
                      is_admin == 1) && (
                      <>
                        <div className="col-md-2">
                          <div className="mb-3">
                            <label className="form-label required">
                              Department
                            </label>
                            {dptListing ? (
                              
                              <select
                                className="form-select form-control"
                                name="srchEmpDepartment"
                                id="srchEmpDepartment"
                                placeholder="Select status"
                                onChange={(e) =>
                                  fetchDesigtList(e.target.value)
                                }
                                value={srchEmpDepartment}
                              >
                                <option value="">Select</option>
                                {dptListing.map((element, key) => (
                                  <option key={key} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <DivSpinner size="sm" color="primary" />
                            )}
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="mb-3">
                            <label className="form-label required">
                              Designation
                            </label>
                            {desigListing ? (
                              <select
                                className="form-select form-control"
                                name="designation"
                                id="designation"
                                placeholder="Select designation"
                                onChange={(e) =>
                                  setsrchDesignation(e.target.value)
                                }
                                value={srchdesignation}
                              >
                                <option value="">Select</option>
                                {desigListing &&
                                  desigListing.map((element, key) => (
                                    <option key={key} value={element.id}>
                                      {element.name}
                                    </option>
                                  ))}
                              </select>
                            ) : (
                              <DivSpinner size="sm" color="primary" />
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-md-2">
                      <div className="mb-3">
                        <label className="form-label required">Status</label>
                        <select
                          className="form-select form-control"
                          name="srchEmpStatus"
                          id="srchEmpStatus"
                          placeholder="Select status"
                          onChange={(e) => setSrchEmpStatus(e.target.value)}
                          value={srchEmpStatus}
                        >
                          <option value="">Select</option>
                          <option value="Pending">Pending</option>
                          <option value="Approved">Approved</option>
                          <option value="Rejected">Rejected</option>
                          <option value="Withdrawn">Withdrawn</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-3">
                        <label className="form-label">&nbsp;</label>
                        <div>
                          <button
                            type="button"
                            name="btnSearch"
                            id="btnSearch"
                            className="btn btn-blue d-none d-sm-inline-block mr-2"
                            onClick={handleSearch}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon icon-tabler icon-tabler-search"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              ></path>
                              <circle cx="10" cy="10" r="7"></circle>
                              <line x1="21" y1="21" x2="15" y2="15"></line>
                            </svg>
                            Search
                          </button>
                          <button
                            type="button"
                            name="btnSearchReset"
                            id="btnSearchReset"
                            className="btn btn-outline-primary mr-2"
                            onClick={handleReSetSearch}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon icon-tabler icon-tabler-x"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              ></path>
                              <line x1="18" y1="6" x2="6" y2="18"></line>
                              <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <nav className="limit-pagination pt-3">
                        <span className="">Rows per page:</span>
                        <select
                          aria-label="Rows per page:"
                          className="sc-cwSeag jaZsat"
                          value={perPage}
                          onChange={(e) => handlePageLimit(e.target.value)}
                        >
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path d="M7 10l5 5 5-5z"></path>
                          <path d="M0 0h24v24H0z" fill="none"></path>
                        </svg>
                      </nav>
                    </div>
                  </div>
                </div>
                <div >
                  <DataTable
                    columns={columns}
                    data={data}
                    progressPending={loading}
                    progressComponent={<CustomLoader />}
                    pagination="true"
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    paginationPerPage={perPage}
                    paginationComponent={BootyPagination}
                    sortServer
                    onSort={handleSort}
                  />
                </div>
                <div className="card-footer d-flex align-items-center">
                  <p className="m-0 text-muted">
                    Showing <span>{totalRecords}</span> entries
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* OPEN MODAL */}
      {showEmpDetailsModel.show === "show" && (
        <ShowDetails
          closeEmpDetails={closeEmpDetails}
          editEmpId={editEmpId}
          firstName={firstName}
          lastName={lastName}
        />
      )}
      {showResignationModal.show === "show" && (
        <ModalViewResignation
          closeResignationModal={closeResignationModal}
          EmpId={editEmpId}
          resignationData={resignationData}
        />
      )}
      {showAccountClearanceModal.show === "show" && (
        <AccountClearance
          closeAccountClearanceModal={closeAccountClearanceModal}
          EmpId={editEmpId}
          resignationData={accountClearanceData}
        />
      )}
      {showItCheckModal.show === "show" && (
        <ITCheck
          closeItCheckModal={closeItCheckModal}
          resignationData={itCheckData}
          // Try one of these if euser_id is wrong:
          employeeId={
            itCheckData?.user_id ||
            itCheckData?.employee_id ||
            itCheckData?.emp_id
          }
        />
      )}
    </>
  );
}

export default ResignationList;